export const CALENDAR_EVENT_SYMBOLS = {
  holiday: '🎄',
  dayOff: '🏖️',
  teamMeeting: '🗣️',
  pendingCustomerPo: '🛒',
  notes: '📝',
  shipOnly: '🚚',
} as const;
